import React from 'react';
import { ClosingCTA, Container, Eyebrow, PageHero, Section, sectionHeadingClass } from '../components/ui/Primitives';
import { Seo } from '../components/seo/Seo';
import { images, serviceCategories } from '../data/site';
import { pageSeo } from '../data/seo';
import { breadcrumbSchema, legalServiceSchema, organizationSchema, webPageSchema } from '../utils/schema';
const seo = pageSeo.services;
const crumbs = [{
  label: 'Home',
  path: '/'
}, {
  label: 'Services',
  path: '/services'
}];
export function Services() {
  return <>
      <Seo title={seo.title} description={seo.description} path={seo.path} keywords={seo.keywords} image={images.architecture} schemas={[organizationSchema, legalServiceSchema, webPageSchema({
      ...seo
    }), breadcrumbSchema(crumbs)]} data-id="element-359" data-mp="3tbqqhivjod93" />

      <PageHero eyebrow="Services" title="Legal Services Designed for Modern Needs" subtitle="NexLaw focuses on practical legal services for individuals, families, and businesses." crumbs={crumbs} data-id="element-360" data-mp="27wuqk5fgxllp" />

      <Section ariaLabel="Service categories" data-id="element-361" data-mp="1boflx6yuhj8t">
        <div className="grid gap-14 md:gap-20" data-id="element-362" data-mp="1fprara9wa0fy">
          {serviceCategories.map((category, index) => <article key={category.id} id={category.id} aria-labelledby={`${category.id}-heading`} className="grid scroll-mt-24 gap-6 border-t border-ink pt-6 md:grid-cols-12 md:gap-12 md:pt-8" data-id="element-363" data-mp="1kgr98jynwqkk" data-mpi={index}>
              <div className="md:col-span-1" data-id="element-364" data-mp="1ug8ckuqfysdd">
                <span className="font-display text-[13px] tracking-[0.14em] text-navy md:text-mist" data-id="element-365" data-mp="1zd8f4vo31czq">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="md:col-span-5" data-id="element-366" data-mp="508tolx0tokj">
                <h2 id={`${category.id}-heading`} className="font-display text-[28px] font-medium leading-[1.08] tracking-tightest text-ink sm:text-[32px] md:text-[38px]" data-id="element-367" data-mp="51k2j05bpmii">
                  {category.title}
                </h2>
                <p className="mt-4 max-w-prose text-[16px] leading-relaxed text-graphite" data-id="element-368" data-mp="17egaq3ggk8by">
                  {category.intro}
                </p>
              </div>
              <ul className="grid gap-y-3 md:col-span-6 md:grid-cols-2 md:gap-x-8" data-id="element-369" data-mp="1hatanj2ljif5">
                {category.items.map(item => <li key={item} className="border-b border-line pb-3 text-[15.5px] text-graphite" data-id="element-370" data-mp="1v8zq7j3ogvq0">
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </Section>

      {/* Jurisdictions */}
      <section aria-labelledby="jurisdictions-heading" className="border-y border-line bg-sand/60" data-id="element-371" data-mp="2e1bsk5ubzx05">
        <Container className="py-20 md:py-28 lg:py-32" data-id="element-372" data-mp="2930fzncnj8e8">
          <div className="grid gap-10 md:grid-cols-12 md:items-center md:gap-16" data-id="element-373" data-mp="2905zg6wre7q3">
            <div className="md:col-span-6" data-id="element-374" data-mp="2sotx947w8rmk">
              <Eyebrow data-id="element-375" data-mp="2xmvk808fxb3b">Where we practise</Eyebrow>
              <h2 id="jurisdictions-heading" className={`mt-6 md:mt-7 ${sectionHeadingClass}`} data-id="element-376" data-mp="2xmca35p17qzu">
                Serving Ontario and Quebec.
              </h2>
              <p className="mt-6 max-w-prose text-[16.5px] leading-relaxed text-graphite md:text-[17px]" data-id="element-377" data-mp="2nn4nrt0bkm0l">
                NexLaw is initially focused on Ontario and Quebec. Additional
                jurisdictions may be considered in the future.
              </p>
              <div className="mt-9 flex gap-px overflow-hidden rounded-sm bg-line md:mt-10" data-id="element-378" data-mp="200emitvsovh1">
                {['Ontario', 'Quebec'].map(province => <div key={province} className="flex-1 bg-paper px-5 py-5 sm:px-6 sm:py-6" data-id="element-379" data-mp="24w3rxduhx6l9">
                    <p className="font-display text-[19px] font-medium text-ink sm:text-[20px]" data-id="element-380" data-mp="1r11bhws0vyu7">
                      {province}
                    </p>
                    <p className="mt-1 text-[14px] text-mist" data-id="element-381" data-mp="1nw0x48abhk32">Active focus</p>
                  </div>)}
              </div>
            </div>
            <figure className="md:col-span-6" data-id="element-382" data-mp="1e795k19651so">
              <img src={images.architecture} alt="Modern architectural detail representing structure and clarity in legal services" width={1000} height={1250} loading="lazy" decoding="async" className="aspect-[4/3] w-full rounded-sm object-cover md:aspect-[4/5]" data-id="element-383" data-mp="1e5y2k3njry2m" />
            </figure>
          </div>
        </Container>
      </section>

      <ClosingCTA headline="Not sure where your matter fits?" body="Describe the situation in a few sentences and we will point you in the right direction." data-id="element-384" data-mp="r72zmib6n827" />
    </>;
}